import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes";
import SiteFooter from "./SiteFooter";
import "./NotFound.css";

const NotFound: React.FC = () => (
  <main className="not-found-page">
    <div className="not-found-container">
      <h1>Page not found</h1>
      <p>
        That page does not exist. Choose a calculator below or return to the
        home page.
      </p>
      <nav className="not-found-links" aria-label="Popular pages">
        <Link to={ROUTES.home}>Home</Link>
        <Link to={ROUTES.tax}>Tax calculator</Link>
        <Link to={ROUTES.bondRepayment}>Bond repayment</Link>
        <Link to={ROUTES.carAffordability}>Car affordability</Link>
      </nav>
      <SiteFooter />
    </div>
  </main>
);

export default NotFound;
